<template>
  <form @submit.prevent.stop="submit()">
    <div class="columns is-multiline">
      <div class="column is-12 is-paddingless">
        <div v-if="isNew" class="columns">
          <div class="column">
            <div class="title is-4">
              <b>Création d'un mandat sur ce programme</b>
              <!--<span class="is-size-3 is-margin-left-xsmall icon is-small"
                    v-helper.bottom.small="''">
                <i class="fas fa-question-circle fa-xs has-text-grey"></i>
              </span>-->
            </div>
          </div>
        </div>
        <div v-if="isDistributeurMode && isNew && !programPk && !promoteurPk" class="columns">
          <div class="column is-6 is-paddingless-top">
            <div class="field">
              <span class="label">Promoteurs</span>
              <div v-if="promoteurs">
                <multiselect v-model="promoteursChoosen" :options="promoteurs"
                            class="multiselect--option-ico multiselect--tagsSmall"
                             :searchable="true" value="pk"
                             name="promoteurs" :disabled="all_promoteurs"
                             data-vv-as="Promoteurs" :placeholder="''"
                             :close-on-select="true" :show-labels="false"
                             label="name" track-by="pk" @search-change="getPromoteurs">
                  <span slot="placeholder"
                        class="multiselect__placeholder">Sélectionnez ou saisissez un promoteur</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
                <p v-if="errors.has('promoteurs')" class="help is-danger">
                  {{errors.first('promoteurs')}}
                </p>
              </div>
            </div>
          </div>
          <div class="column is-5 is-paddingless-top">
            <div class="field">
              <span class="label is-padding-bottom-small">Tous les promoteurs</span>
              <input id="all_promoteurs" type="checkbox" name="all_promoteurs"
                     class="switch is-success is-success is-rounded is-medium"
                     v-model="all_promoteurs">
              <label for="all_promoteurs" class="is-size-6 is-uppercase">{{promoteurs.length}} promoteur(s)</label>
            </div>
          </div>
        </div>
        <div v-if="isNew && !programPk" class="columns">
          <div class="column is-6 is-paddingless-top">
            <div class="field">
              <div class="label">Programmes<i class="fal fa-spinner fa-spin is-margin-left-xsmall" v-if="loadingPrograms"></i></div>
              <div v-if="programs">
                <multiselect v-model="programsChoosen" :options="programs" :multiple="true"
                             class="multiselect--option-ico multiselect--tagsSmall"
                             :searchable="true" value="pk" :placeholder="''"
                             name="programs" :disabled="all_programs"
                             v-validate="'required'" data-vv-as="Programmes"
                             :close-on-select="false" :show-labels="false"
                             label="name" track-by="pk" @search-change="getPrograms">
                  <span slot="placeholder"
                        class="multiselect__placeholder">Sélectionnez ou saisissez un programme</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
                <p v-if="errors.has('programs')" class="help is-danger">
                  {{errors.first('programs')}}
                </p>
              </div>
            </div>
          </div>
          <div class="column is-5 is-paddingless-top">
            <div class="field">
              <span class="label is-padding-bottom-small">Tous les programmes</span>
              <input id="all_programs" type="checkbox" name="all_programs"
                     class="switch is-success is-success is-rounded is-medium"
                     v-model="all_programs">
              <label for="all_programs" class="is-size-6 is-uppercase">{{programs.length}} programme(s)</label>
            </div>
          </div>
        </div>
        <div v-if="isNew && !sourceCompany" class="columns">
          <div class="column is-6 is-paddingless-top">
            <div class="field">
              <span class="label">Sociétés</span>
              <div v-if="companies">
                <multiselect v-model="companiesChoosen" name="companies" :options="sortedCompanies" :multiple="true"
                             :custom-label="val => `${val.name}${val.remuneration ? ` (${val.remuneration}%)` : ''}`"
                             class="multiselect--option-ico multiselect--tagsSmall"
                             :close-on-select="false" :disabled="all_companies" :placeholder="''"
                             v-validate="'required'" @search-change="getCompanies"
                             data-vv-as="Société"
                             group-values="companies" group-label="remuneration" :group-select="true"
                             label="name" track-by="pk">
                  <span slot="placeholder" class="multiselect__placeholder">Sélectionnez ou saisissez une société</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
                <p v-if="errors.has('companies')" class="help is-danger">
                  {{errors.first('companies')}}
                </p>
              </div>
            </div>
          </div>
          <div class="column is-5 is-paddingless-top">
            <div class="field">
              <span class="label is-padding-bottom-small">Toutes les sociétés</span>
              <input id="all_companies" type="checkbox" name="all_companies"
                     class="switch is-success is-success is-rounded is-medium"
                     v-model="all_companies">
              <label for="all_companies" class="is-paddingless-top is-uppercase"><span class="is-size-6 is-padding-top-xsmall">{{companies.length}} société(s)</span></label>
            </div>
          </div>
        </div>
        <div v-if="!isNew && fromQuickview" class="columns is-multiline">
          <div class="column is-12 is-padding-top-xsmall">
            <span>Société : <b>{{access.company_name}}</b> <br>
              <span v-if="currentCompany">Rémunération : {{currentCompany.remuneration || '-'}} %</span></span>
          </div>
          <div class="column is-12 is-padding-top-xsmall">
            <span>Programme : <b>{{access.program_name}}</b><br>
              <span v-if="currentProgram">Taux commercialisateur : {{currentProgram.remuneration || '-'}} %</span></span>
          </div>
        </div>
        <div class="columns is-multiline"
          :class="!isNew ? 'is-padding-top-small' : ''"
        >
          <div class="column is-padding-top-xxsmall" :class="fromQuickview ? 'is-12' : 'is-12 is-5-widescreen is-4-fullhd'">
            <div class="title is-5 has-text-weight-bold is-margin-bottom-xsmall">Date d'ouverture et de clôture</div>
            <div class="field has-addons">
              <div class="control">
                <a class="button is-square is-static is-border is-min-width-0">
                  <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                </a>
              </div>
              <div class="control is-expanded has-icons-right">
                <flat-pickr :config="configDate"
                            @input="dateInput"
                            v-model="accessDate"
                            class="input e is-paddingless-right"
                            name="date"
                            :class="[{'is-danger': errors.has('date')}, 'is-padding-left-xxsmall is-paddingless-right']"
                            v-validate="'required'"
                            data-vv-as="Date d'ouverture et de clôture"></flat-pickr>
                <p v-if="errors.has('date')" class="help is-danger">{{errors.first('date')}}</p>
              </div>
              <div class="control">
                <a class="button is-grey is-inverted is-border is-square" @click="accessDate = []">
                  <i class="fal fa-times"></i>
                </a>
              </div>
            </div>
          </div>
          <!-- <div class="column is-4" :class="access.pk && fromQuickview ? 'is-8' : 'is-4'">
            <label class="label">Date fin du mandat</label>
            <div class="field has-addons">
              <div class="control">
                <a class="button is-static is-border is-min-width-0">
                  <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                </a>
              </div>
              <div class="control is-expanded has-icons-right">
                <flat-pickr :config="endDateConfig" @on-open="endDateOpened = true" @on-close="endDateClosed = true"
                            v-model="a.end_date" class="input is-radiusless" name="endDate"
                            :class="{'is-danger': errors.has('endDate')  && endDateOpened && endDateClosed}"
                            v-validate="'required'" data-vv-as="Date fin du mandat"></flat-pickr>
                <p v-if="errors.has('endDate') && endDateOpened && endDateClosed" class="help is-danger">
                  {{errors.first('endDate')}}</p>
              </div>
              <div class="control">
                <a class="button is-square is-radiusless" @click="a.end_date = null">
                  <i class="fal fa-times"></i>
                </a>
              </div>
            </div>
          </div> -->
          <div class="column is-paddingless-bottom is-padding-top-xxsmall"
                :class="fromQuickview ? 'is-12' : 'is-12 is-7-widescreen is-8-fullhd'">
            <div class="columns is-gapless">
              <div class="column is-12">
                <div class="title is-5 is-margin-bottom-xsmall">
                  <b>Taux de rémunération appliqué</b>
                  <span class="is-size-3 is-margin-left-xsmall icon is-small"
                        v-helper.bottom.small="'6pIcwkqLMQ0eykiogiqiwI'">
                    <i class="fas fa-question-circle fa-xs has-text-grey"></i>
                  </span>
                </div>
              </div>
              <!-- <div class="column is-narrow">
                <span class="has-text-grey"><i>Taux spécifique</i></span>
              </div> -->
            </div>
            <div class="column is-gapless is-paddingless is-12 columns is-multiline is-vcentered">
              <div class="column is-8 is-12-widescreen is-8-fullhd is-paddingless columns is-variable is-2 is-multiline">
                <div class="column is-4 is-paddingless-top is-paddingless-left is-padding-right-small">
                  <input id="useProgramRemuneration" name="useProgramRemuneration"
                        class="checkradiocase is-primary is-fullwidth"
                        type="radio" :value="REMUNERATION_MODES.PROGRAM" v-model="remunerationMode">
                  <label class="has-text-weight-light" for="useProgramRemuneration">
                    <span class="is-size-6">
                      Programme&nbsp;
                      <span v-if="(sourceProgram && sourceProgram.remuneration || program && program.remuneration) && displayRemuneration">
                        ({{sourceProgram.remuneration || program.remuneration}}%)
                      </span>
                    </span>
                  </label>
                </div>
                <div class="column is-4 is-paddingless-top is-paddingless-left is-padding-right-small">
                  <input id="useCompanyRemuneration" name="useCompanyRemuneration" checked="checked"
                        class="checkradiocase is-primary is-fullwidth"
                        type="radio" :value="REMUNERATION_MODES.COMPANY" v-model="remunerationMode" @click="getCompany">
                  <label class="has-text-weight-light" for="useCompanyRemuneration">
                    <span class="is-size-6">
                      Société&nbsp;
                      <span v-if="companiesChoosen && companiesChoosen.length === 1 && displayRemuneration && companiesChoosen[0].remuneration">
                        ({{companiesChoosen[0].remuneration}}%)
                      </span>
                    </span>
                  </label>
                </div>
                <div class="column is-4 is-paddingless-top is-paddingless-left is-padding-right-small"
                    v-if="remunerationMode !== REMUNERATION_MODES.CUSTOM">
                  <input id="useCustomRemuneration" name="useCustomRemuneration"
                        class="checkradiocase is-primary is-fullwidth"
                        type="radio" :value="REMUNERATION_MODES.CUSTOM" v-model="remunerationMode">
                  <label class="has-text-weight-light" for="useCustomRemuneration">
                    <span class="is-size-6">Taux spécifique</span>
                  </label>
                </div>
                <div v-else class="column is-4 is-paddingless-top is-paddingless-left field has-addons">
                  <div class="control is-expanded has-incrementations">
                    <input id="email" name="remuneration" v-model="a.remuneration" max="100"
                          type="number"
                          class="checkradiocase is-input is-primary is-fullwidth is-active"
                          :class="{'is-danger' : errorNan}" ref="custominput">
                    <div class="incrementation">
                      <a @click.stop="a.remuneration++"  class="incrementation-btn has-bg-light"><i class="fas fa-chevron-up"></i></a>
                      <a @click.stop="a.remuneration--"  class="incrementation-btn has-bg-light"><i class="fas fa-chevron-down"></i></a>
                    </div>
                  </div>
                  <div class="control">
                    <a class="button is-square is-static is-border is-radius-top-right is-radius-bottom-right is-min-width-0">
                      <span class="icon"><i class="fas fa-percentage"></i></span>
                    </a>
                  </div>
                </div>
                <div class="column is-12 is-padingless-top" v-if="errorNan">
                  <div class="notification is-danger is-radius-large is-padding-small">
                    <p class="is-margin-right">
                      <i
                        class="fal fa-comment-alt-exclamation fa-lg is-inline-block is-vcentered is-margin-right-xsmall"></i>
                      Veuillez saisir une rémunération correcte.</p>
                  </div>
                </div>
              </div>
              <div v-if="isAdmin && sourceProgram" class="column is-4 is-8-widescreen is-4-fullhd is-self-flex-start is-padding-bottom">
                <a class="button is-fullwidth is-border is-transform-none" @click="openLotSelectionQuickView">
                  <span class="icon is-small"><i class="fas fa-tasks"></i></span>
                  <span>{{allotments && allotments.length ? 'Modifier' : 'Créer un'}} allotement</span>
                </a>
              </div>
            </div>
          </div>
          <div v-if="(allotments && allotments.length) || (newAllotments && newAllotments.length)" class="column is-paddingless-top"
               :class="fromQuickview ? 'is-12' : 'is-7 is-6-fullhd'">
            <p class="has-text-grey is-size-6 has-text-weight-medium is-margin-bottom-small">
              Allotement. Seul ces lots sont visibles par la société
              <span class="is-size-3 is-margin-left-xsmall icon is-small" v-helper.bottom.small="'1VFo2p1joZb6WrG08zv5Ee'">
                <i class="fas fa-question-circle fa-xs has-text-grey"></i>
              </span>
            </p>
            <div class="tags">
              <span v-if="!newAllotments" v-for="all in allotments" :key="all.pk"
                    class="tag is-allotement is-margin-right-xsmall is-normal w-auto">{{all.lot_ref}}</span>
              <span v-if="newAllotments" v-for="newAll in newAllotments" :key="newAll.pk"
                    class="tag is-allotement is-margin-right-xsmall is-normal w-auto">{{newAll.ref}}</span>
            </div>
          </div>
        </div>
        <div class="has-bg-warning columns is-vcentered">
          <div class="column is-narrow is-padding-small">
            <a class="button is-circle is-static is-medium">
              <i class="fal fa-lightbulb-on fa-lg"></i>
            </a>
          </div>
          <div class="column is-paddingless-left is-padding-top-small is-padding-bottom-small">
            <div class="is-italic is-size-6">
              <b class="is-uppercase">Le taux programme : </b>
              <span>Le taux de rémunération appliqué est celui de commercialisation du programme.</span>
            </div>
            <div class="is-italic is-size-6">
              <b class="is-uppercase">Le taux société : </b>
              <span>La société reçoit le montant de rémunération définie dans la fiche de la société.</span>
            </div>
            <div class="is-italic is-size-6">
              <b class="is-uppercase">Taux spécifique : </b>
              <span>Vous définissez un taux libre et spécifique qui doit d'appliquer à la ou les société(s) pour ce(s) programme(s)</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span v-if="canCreateAccess"></span>
    <span v-if="canUpdateAccess"></span>
  </form>
</template>

<script>
  import { isNil, groupBy, isEmpty, sortBy } from 'lodash'
  import moment from 'moment'
  import { DefaultValues } from '../../mixins'
  import { mapState, mapGetters } from 'vuex'

  const emptyAccess = {
    companies: null,
    program: null,
    start_date: null,
    end_date: null,
    remuneration: null
  }

  const REMUNERATION_MODES = Object.freeze({
    COMPANY: 'COMPANY',
    PROGRAM: 'PROGRAM',
    CUSTOM: 'CUSTOM'
  })

  export default {
    name: 'AccessForm',
    mixins: [DefaultValues],
    props: {
      createMode: {
        type: Boolean,
        default: true
      },
      loading: {
        type: Boolean,
        default: false
      },
      source: {
        type: Object,
        required: false
      },
      simulateSubmit: {
        type: Boolean,
        default: false
      },
      sourceProgram: [Object, String],
      sourceLots: Array,
      sourcePromoteur: [Object, String],
      sourceCompany: [Object, String],
      fromQuickview: Boolean
    },
    data () {
      return {
        all_companies: false,
        all_programs: false,
        all_promoteurs: false,
        configDate: {
          altFormat: 'j/m/Y',
          altInput: true,
          dateFormat: 'd/m/Y',
          mode: 'range'
        },
        currentProgram: null,
        currentCompany: null,
        useCompanyRemuneration: false,
        useProgramRemuneration: true,
        programAlreadyLoaded: false,
        endDateOpened: false,
        endDateClosed: false,
        startDateOpened: false,
        startDateClosed: false,
        access: {},
        company: null,
        companies: [],
        companyPk: null,
        companiesChoosen: [],
        REMUNERATION_MODES: REMUNERATION_MODES,
        program: null,
        programs: [],
        programPk: this.$route.query.program,
        programChoosen: null,
        programsChoosen: [],
        promoteur: null,
        promoteurs: [],
        promoteurPk: null,
        promoteursChoosen: null,
        remunerationMode: null,
        selectAll: false,
        errorNan: false,
        loadingPrograms: false,
        accessDate: [],
        allotments: [],
        newAllotments: null
      }
    },
    computed: {
      ...mapState({
        currentUser: 'currentUser',
        quickview: 'quickview',
        promoteursList: 'promoteurs',
        companiesList: 'companies'
      }),
      ...mapGetters(['isDistributeurMode', 'displayRemuneration', 'isAdmin']),
      startDateConfig () {
        let config = Object.assign({}, this.configDate)
        return config
      },
      endDateConfig () {
        let config = Object.assign({}, this.configDate)
        if (this.access.start_date) {
          config.minDate = this.access.start_date
        } else {
          config.minDate = new Date()
        }
        return config
      },
      a () {
        return this.access
      },
      isNew () {
        return isNil(this.access.pk)
      },
      canCreateAccess () {
        let canCreateAccess = ((this.companiesChoosen && this.companiesChoosen.length > 0) || this.all_companies === true) &&
                                      (this.accessDate && this.accessDate.length > 0) &&
                                      this.remunerationMode
        this.$emit('canCreateAccess', canCreateAccess)
        return canCreateAccess
      },
      canUpdateAccess () {
        let canUpdateAccess = !isEmpty(this.accessDate)
        this.$emit('canUpdateAccess', canUpdateAccess)
        return canUpdateAccess
      },
      sortedCompanies () {
        let grouped = groupBy(this.companies, 'remuneration')
        let groupedKeys = Object.keys(grouped).map(key => {
          let value = key !== 'null' ? `Rémunération à ${key}%` : 'Sans rémunération définie'
          return {remuneration: value, companies: grouped[key], key: Number(key).toFixed(1)}
        })
        return sortBy(groupedKeys, 'key')
      }
    },
    watch: {
      simulateSubmit (to, from) {
        if (to && to !== from) {
          this.submit()
        }
      },
      source () {
        this.updateSource()
      },
      'a.remuneration' (v) {
        this.errorNan = Number.isNaN(Number(v)) || Number(v) > 100
      },
      remunerationMode (v) {
        this.$nextTick(() => {
          if (this.remunerationMode === REMUNERATION_MODES.CUSTOM && this.$refs.custominput) {
            this.$refs.custominput.focus()
          }
        })
      },
      promoteursChoosen () {
        if (!this.sourceProgram) {
          this.getPrograms()
        }
      },
      all_promoteurs (v) {
        if (v) {
          this.promoteursChoosen = null
        }
        this.getPrograms()
      },
      all_companies (v) {
        if (v) this.companiesChoosen = null
      },
      all_programs (v) {
        if (v) this.programsChoosen = null
      },
      quickview ({mode, params, results}) {
        if (results && mode === 'LOT_SELECTION') {
          this.$set(this, 'newAllotments', results)
        }
      }
    },
    methods: {
      companyName (value) {
        let name = []
        name.push(value.name)
        if (value.remuneration) {
          name.push('(' + value.remuneration + '%)')
        }
        return name.join(' ')
      },
      dateInput (e) {
        let newDate = e.split(' au ')
        if (newDate && newDate.length > 1 && newDate[0] && newDate[1]) {
          this.access.start_date = newDate[0]
          this.access.end_date = newDate[1]
        }
      },
      submit () {
        if (this.errorNan || !this.remunerationMode || (this.remunerationMode === REMUNERATION_MODES.CUSTOM && !this.a.remuneration)) {
          return this.$notify({
            type: 'is-danger',
            text: 'Veuillez saisir une rémunération correcte'
          })
        }
        this.$validator.validateAll()
          .then(isValid => {
            if (isValid) {
              if (this.all_companies) {
                this.access.all_companies = true
                this.access.companies = []
              } else {
                this.access.all_companies = false
                this.access.companies = this.companiesChoosen
              }

              if (this.all_programs && !isEmpty(this.promoteursChoosen)) {
                this.access.all_programs = true
                this.access.program = null
                this.access.promoteurs = [this.promoteursChoosen.pk]
              } else if (this.all_programs && isEmpty(this.promoteursChoosen)) {
                this.access.all_programs = true
                this.access.programs = null
                this.access.promoteurs = []
              } else {
                this.access.all_programs = false
                this.access.programs = this.programsChoosen
                this.access.promoteurs = this.promoteursChoosen ? [this.promoteursChoosen.pk] : []
              }

              if (this.remunerationMode === REMUNERATION_MODES.COMPANY) {
                this.access.use_company_remuneration = true
                this.access.use_program_remuneration = false
                if (this.currentCompany) this.access.remuneration = this.currentCompany.remuneration
              } else if (this.remunerationMode === REMUNERATION_MODES.PROGRAM) {
                this.access.use_company_remuneration = false
                this.access.use_program_remuneration = true
                if (this.program) this.access.remuneration = this.program.remuneration
              } else {
                this.access.use_company_remuneration = false
                this.access.use_program_remuneration = false
              }
              if (this.programPk) this.access.programs = [this.programPk]
              if (this.promoteurPk) this.access.promoteurs = [this.promoteurPk]
              if (this.companyPk) this.access.companies = [this.companyPk]
              if (!isNil(this.access.remuneration)) {
                this.access.remuneration = String(this.access.remuneration)
              }
              if (!this.access.start_date) this.access.start_date = this.accessDate[0]
              if (!this.access.end_date) this.access.end_date = this.accessDate[1]
              if (this.newAllotments) {
                this.access.newAllotments = this.newAllotments
                if (this.createMode) {
                  this.access.allotments = this.newAllotments.map(x => x.pk)
                } else {
                  this.access.allotments = this.allotments
                }
              }
              this.$emit('submit', this.access)
            } else {
              this.$emit('failed', this.access)
              this.$notify({
                type: 'is-danger',
                text: 'Oups ! Merci de compléter les champs obligatoires.'
              })
            }
          })
          .catch(() => {
            this.$emit('failed', this.access)
          })
      },
      getCompanies (query, init = null) {
        this.$api.companyService.get({name: query, per_page: 100}).then(res => {
          this.companies = res.data.items
          if (init) {
            let company = this.companies.find(x => x.pk === this.$route.query.company)
            if (company) {
              this.access.company = company
              this.companiesChoosen = company
            }
          }
        })
      },
      getCompany () {
        if (this.source && this.source.company) {
          this.$api.companyService.getOne(this.source.company.pk || this.source.company).then(r => {
            this.currentCompany = r.data
          })
        }
      },
      getPromoteurs (query, page = 1) {
        this.$api.promoteurService.get({name: query, per_page: 100, page}).then(res => {
          this.promoteurs = res.data.items
          if (res.data.page < res.data.pages) {
            page++
            this.getPromoteurs(query, page)
          }
        })
      },
      getPrograms (query, page = 1, init = true) {
        this.loadingPrograms = true
        if (init) {
          this.programs = []
        }
        let filters = {}
        if (query) {
          filters.name = query
        }
        if (!isNil(this.promoteurPk)) {
          filters.promoteur = this.promoteurPk
        } else if (!isEmpty(this.promoteursChoosen)) {
          filters.promoteur = this.promoteursChoosen.pk
        }

        this.$api.programService.get(Object.assign(filters, {page, per_page: 100})).then(res => {
          let programsPk = this.programs.map(x => x.pk)
          let newPrograms = res.data.items.filter(x => !programsPk.includes(x.pk))

          this.programs = this.programs.concat(newPrograms)
          this.loadingPrograms = false

          if (res.data.page < res.data.pages) {
            page++
            this.getPrograms(query, page, false)
          }
        }).catch(() => {
          this.loadingPrograms = false
        })
      },
      updateSource () {
        if (this.source) {
          this.access = Object.assign({}, this.source)
          if (this.source.program) {
            this.$api.programService.getOne(this.source.program).then(r => {
              this.currentProgram = r.data
            })
          }
          this.remunerationMode = REMUNERATION_MODES.CUSTOM
          if (this.source.company) {
            this.$api.companyService.getOne(this.source.company).then(r => {
              this.currentCompany = r.data
            })
          }
          this.accessDate = [
            moment(this.source.start_date, 'DD/MM/YYYY').format('DD/MM/YYYY'),
            moment(this.source.end_date, 'DD/MM/YYYY').format('DD/MM/YYYY')
          ]
        } else {
          this.companies = this.companiesList.slice()
          this.access = Object.assign({}, emptyAccess)
          this.accessDate = [
            moment().format('DD/MM/YYYY'),
            moment().add(1, 'year').format('DD/MM/YYYY')
          ]
        }
        if (this.sourcePromoteur) {
          this.promoteurPk = this.sourcePromoteur.pk || this.sourcePromoteur
        } else if (this.isDistributeurMode) {
          this.promoteurs = this.promoteursList.slice()
        }
        if (this.sourceProgram) {
          if (this.sourceProgram.pk) {
            this.programPk = this.sourceProgram.pk
            this.program = this.sourceProgram
          } else {
            this.$api.programService.getOne(this.sourceProgram).then(r => {
              this.programPk = r.data.pk
              this.program = r.data
            })
          }
        } else {
          this.getPrograms()
        }
        if (this.source && this.sourceProgram) {
          this.$api.accessService.getLotFromAccesses(this.source.pk).then(r => {
            this.allotments = r.data.items
          })
        }
        if (this.sourceCompany) {
          if (this.sourceCompany.pk) {
            this.companyPk = this.sourceCompany.pk
            this.companiesChoosen = [this.sourceCompany]
          } else {
            this.$api.companyService.getOne(this.sourceCompany).then(r => {
              this.companyPk = r.data.pk
              this.companiesChoosen = [r.data]
            })
          }
        } else {
          this.companies = this.companiesList.slice()
        }
      },
      openLotSelectionQuickView () {
        this.$store.commit('setQuickview', {mode: 'LOT_SELECTION', params: {source: this.sourceProgram, mode: 'append', lots: this.allotments, sourceLots: this.sourceLots}})
      }
    },
    created () {
      this.updateSource()
      this.getCompany()
    }
  }
</script>

<style scoped>
.tag.w-auto {
  width: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/access/AccessForm.vue